/**
 * @file    routes/protected.jsx - Exports a react component representing all the
 *          possible routes the web page can navigate to.
 *
 * @author  Bryan Hoang <bryan@distributive.network>
 * @date    Aug. 2023
 */

// Maintain the prevailing brace style to make it easier to parse the routes using sed.
/* eslint-disable @distributive/brace-style */

import { Outlet, Navigate } from 'react-router-dom';

import { AccountsPage, HistoryPage } from '@/features/accounts';
import { WorkerPage } from '@/features/worker';
import { UserPage } from '@/features/user';
import { Callback } from '@/features/auth';
import { PrivacyPolicyPage, TermsOfServicePage, AboutPage, IFramePage } from '@/features/misc';


function App()
{
  return (
    <Outlet />
  );
}

export const protectedRoutes = [
  {
    path: '/',
    element: <App />,
    children: [
      { path: '/auth/callback', element: <Callback /> },
      { path: '/', element: <Callback useDefault={ true } /> },
      { path: '/accounts', element: <AccountsPage /> },
      { path: '/accounts/history', element: <HistoryPage /> },
      { path: '/portal-worker', element: <WorkerPage /> },
      { path: '/user', element: <UserPage /> },
      { path: '/about', element: <AboutPage /> },
      { path: '/policy', element: <PrivacyPolicyPage /> },
      { path: '/tos', element: <TermsOfServicePage /> },
      // `iframe` based pages.
      { path: '/workers', element: <IFramePage /> },
      { path: '/compute-groups', element: <IFramePage /> },
      { path: '/keys', element: <IFramePage /> },
      { path: '/jobs', element: <IFramePage /> },
      { path: '/market', element: <IFramePage /> },
      { path: '/playground', element: <IFramePage /> },
    ],
  },
];
